export function getFontScale(text, initialScale = 1, maxLength = 12, factor = 0.9) {
    if (text === undefined || text === null) return '1em';
    const fontSize = initialScale * Math.min(Math.pow(factor, Math.max(Math.floor((text.length - maxLength) / 2), 0)), 1);
    return fontSize;
}